import request from '@/request'

export async function createUserPlaylistDefaultCourse (userId, courseId) {
  const response = await request({
    url: `/users/${userId}/playlists/courses`,
    method: 'post',
    data: { course_id: courseId }
  })

  return response.data.data
}

export async function getUserPlaylistDefault (userId) {
  const response = await request({
    url: `/users/${userId}/playlists/default`,
    method: 'get'
  })

  return response.data.data
}

export async function deleteUserPlaylistDefaultCourse (userId, playlistCourseId) {
  await request({
    url: `/users/${userId}/playlists/courses/${playlistCourseId}`,
    method: 'delete'
  })
}